﻿import {Delegate} from "../Tools/Delegate.js";
import {OnTokenRefreshed} from "./FetchAbstractHelper.js";
import {String} from "../Tools/Misc.js"
import {ConnectedUser} from "../Model/ConnectedUser.js";
import {HandledError} from "../Tools/HandledError.js";
import {Config} from "../config/Config.js";
import {ResponseApi} from "../Model/ResponseApi.js";
import {JsonFetchJson} from "./FetchHelper.js";
import {Roles, RolesEnum} from "../Variables/RolesEnum";


export const tokenLocalStorageKey = "b2eKlmV4X9_ZYqwpRtFdW";
        export const OnTokenLogin = new Delegate();
        export const OnTokenLogout = new Delegate();

        export class TokenHelper {
            private static _instance: TokenHelper;
            private _maching: Map<string, string>;
            private _exclusion: Array<string>;

            public static get Instance(): TokenHelper {
                if (this._instance == null)
                    this._instance = new TokenHelper();

                return this._instance;
            }

            constructor() {
                this._maching = new Map<string, string>();
                // Claims du nouveau JWT B-Account (ECDSA P-256, généré par
                // BackofficeTokenService côté WEB_API).
                this._maching.set("sub", "Primarykey");
                this._maching.set("exp", "DateExpiration");
                this._maching.set("iss", "Issuer");
                this._maching.set("aud", "Audience");
                // Anciens claims conservés pour rétrocompatibilité d'éventuels
                // jetons de transition.
                this._maching.set("primarykey", "Primarykey");
                this._maching.set("email", "Email");
                this._maching.set("prenom", "Prenom");
                this._maching.set("nom", "Nom");
                this._maching.set("role", "Roles");
                this._maching.set("fkclient", "FkClient");
                this._maching.set("client", "Client");

                this._exclusion = new Array<string>();
                this._exclusion.push("nbf");
                this._exclusion.push("fonction");
                this._exclusion.push("refresh");
                this._exclusion.push("token_type");

                OnTokenRefreshed.Clear("tradify.token.refreshed");
                OnTokenRefreshed.Bind(async (token: string) => {
                    await this.Login(token);
                    console.log("Token refreshed");
                });
            }

            public TokenToConnectedUser = async (token: string): Promise<ConnectedUser> => {
                let result = new ConnectedUser();

                const t = await this.GetPayload(token);
                for (let prop in t) {

                    if (this._exclusion.indexOf(prop) >= 0)
                        continue

                    const userProp = this._maching.get(prop);
                    if (String.IsNullOrEmpty(userProp))
                        throw new HandledError("Le token ne peut pas être lu.");

                    switch (userProp) {
                        case "Roles" :
                            result.Roles = [];
                            t[prop].forEach(x => {
                                x = x.toUpperCase();
                                const r = Roles.Instance.GetById(x);
                                result.Roles.push({
                                    Primarykey: x,
                                    Libelle: r
                                });
                            })
                            break;
                        case "DateExpiration" :
                            result.DateExpiration = new Date(t[prop] * 1000);
                            break;
                        case "Rights":
                            result.Roles = t[prop];
                            break;
                        default :
                            result[userProp] = t[prop];
                    }
                }
                Config.ConnectedUser = result;
                await this.Login(token);
                return result;
            }

            public Logout = async () => {
                Config.ConnectedUser = null;
                OnTokenLogin.Fire();
            }

            public Login = async (token: string) => {
                const cu = Config.ConnectedUser;
                OnTokenLogin.Fire(cu);
            }

            // Lit le JWT B-Account directement depuis le cookie. La logique
            // localStorage est abandonnée — l'authentification est désormais
            // portée par les cookies B-Account / B-RefreshToken.
            public get Token(): string {
                const m = document.cookie.match(/(?:^|;\s*)B-Account=([^;]+)/);
                return m ? decodeURIComponent(m[1]) : null;
            }

            public get TokenExists(): boolean {
                return this.Token != null && this.Token.length > 0;
            }

            // Anciennement : vérifiait /auth/handshake côté WEB_API. Cet
            // endpoint n'existe plus. La validité du B-Account est désormais
            // garantie par le BackofficeTokenValidationMiddleware côté serveur
            // qui valide chaque requête. Si invalide, le serveur ne dépose
            // pas l'utilisateur dans HttpContext et [Authorize] renvoie 401 ;
            // le FetchAbstractHelper redirige alors vers /.
            public CheckToken = async () => {
                console.log("[TokenHelper] CheckToken start");
                if (!this.TokenExists) {
                    console.warn("[TokenHelper] No B-Account cookie, redirecting to /");
                    location.href = "/";
                    return;
                }

                // Décode le payload du B-Account côté client pour alimenter
                // Config.ConnectedUser. Aucun appel réseau.
                try {
                    console.log("[TokenHelper] Decoding payload...");
                    const u = await this.TokenToConnectedUser(this.Token);
                    console.log("[TokenHelper] ConnectedUser:", u);
                } catch (e) {
                    console.error("[TokenHelper] Token decode failed", e);
                    location.href = "/";
                }
            }

            private GetPayload = async (token: string): Promise<any> => {
                const base64Url = token.split('.')[1];
                const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
                const jsonPayload = decodeURIComponent(atob(base64).split('').map(function (c) {
                    return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
                }).join(''));

                return JSON.parse(jsonPayload);
            }
            
            
        }


